module.exports = __webpack_public_path__ + "static/media/16-M-Cure 8.fc403275.jpg";